import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  MenuItem,
  TextField,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Icon,
  Tooltip,
  Snackbar,
  Backdrop,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import ApprovalIcon from "@mui/icons-material/Approval";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";

export const DatabasePage = (props) => {
  const field_types = ["Text", "Number", "Boolean", "Date Time", "Foreign Key"];
  const [tables, setTables] = useState([]);
  const [tableDialog, setTableDialog] = useState(false);
  const [tableName, setTableName] = useState("");

  const [tableNameError, setTableNameError] = useState(false);
  const [tableNameErrorMessage, setTableNameErrorMessage] = useState("");

  const [activeTable, setActiveTable] = useState(null);
  const [fields, setFields] = useState([]);

  const [activeField, setActiveField] = useState(null);

  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState("0");
  const [fieldId, setFieldId] = useState("");
  const [fieldForeign, setFieldForeign] = useState("");
  const [fieldNameError, setFieldNameError] = useState(false);
  const [fieldNameErrorMessage, setFieldNameErrorMessage] = useState("");
  const [fieldForeignError, setFieldForeignError] = useState(false);

  const [fieldDialog, setFieldDialog] = useState(false);
  const [proName, setProName] = useState("");

  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [loader, setLoader] = useState(false);

  let { projectId } = useParams();

  useEffect(() => {
    axios
      .get(`https://api.fabloq.com/user/database/details/${projectId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setTables(res.data.tables);
        setProName(res.data.name);
      });
  }, []);

  const handleAddTable = () => {
    setTableNameError(false);
    if (!Boolean(tableName)) {
      setTableNameError(true);
      setTableNameErrorMessage("Please enter a table name.");
      return;
    }
    let data = {
      name: tableName,
      project: projectId,
    };
    axios
      .post("https://api.fabloq.com/user/database/table/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.status === 226) {
          setTableNameError(true);
          setTableNameErrorMessage(res.data.message);
          return;
        }
        setTableDialog(false);
        handleChangeTable(res.data.tables[res.data.tables.length - 1].id);
        setTables(res.data.tables);
        setTableName("");
      });
  };

  const handleChangeTable = (table_id) => {
    axios
      .get(`https://api.fabloq.com/user/database/table/${table_id}/`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setFields(res.data.fields);
        setActiveTable(table_id);
      });
  };

  const handleNewField = () => {
    setFieldNameError(false);
    setFieldForeignError(false);

    if (!Boolean(fieldName)) {
      setFieldNameError(true);
      setFieldNameErrorMessage("Please enter a field name.");
      return;
    }
    if (fieldType === "4" && !Boolean(fieldForeign)) {
      setFieldForeignError(true);
      return;
    }
    let data = {
      name: fieldName,
      field_type: fieldType,
      table: activeTable,
      foreign_key: fieldForeign,
    };

    axios
      .post("https://api.fabloq.com/user/database/field/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.status === 226) {
          setFieldNameError(true);
          setFieldNameErrorMessage(res.data.message);
          return;
        }
        setFields(res.data.fields);
        setFieldDialog(false);
        setFieldName("");
        setFieldType("0");
        setFieldForeign("");
        setFieldId("");
        setActiveField(false);
      });
  };

  const handleChangeField = () => {
    setFieldNameError(false);

    if (!Boolean(fieldName)) {
      setFieldNameError(true);
      setFieldNameErrorMessage("Please enter a field name.");
      return;
    }
    let data = {
      name: fieldName,
      field_type: fieldType,
      id: fieldId,
    };
    axios
      .put("https://api.fabloq.com/user/database/field/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.status === 226) {
          setFieldNameError(true);
          setFieldNameErrorMessage(res.data.message);
          return;
        }
        setFields(res.data.fields);
        setFieldDialog(false);
        setFieldName("");
        setFieldType("0");
        setFieldId("");
        setFieldForeign("");
        setActiveField(false);
      });
  };

  const handleRemoveField = (id) => {
    axios
      .delete("https://api.fabloq.com/user/database/field/", {
        headers: { Authorization: localStorage.getItem("token") },
        data: {
          id: id,
        },
      })
      .then((res) => {
        setFields(res.data.fields);
      });
  };

  const handleApplyDatabase = () => {
    setLoader(true);
    let data = {
      project: projectId,
    };

    axios
      .post("https://api.fabloq.com/user/database/apply/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setSnackbar(true);
        setSnackbarMessage("Changes Applied to database.");
        setLoader(false);
      })
      .catch((err) => {
        setSnackbar(true);
        setSnackbarMessage("Something went wrong ;(");
        setLoader(false);
      });
  };

  const handleRemoveTable = (id) => {
    axios
      .delete("https://api.fabloq.com/user/database/table/", {
        headers: { Authorization: localStorage.getItem("token") },
        data: {
          table: id,
        },
      })
      .then((res) => {
        setTables(res.data.tables);
        setActiveTable(null);
        setFields([]);
      });
  };

  return (
    <div className="work-page">
      <Backdrop
        open={loader}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <Snackbar
        open={snackbar}
        autoHideDuration={6000}
        onClose={() => {
          setSnackbar(false);
        }}
        message={snackbarMessage}
        className="db-snackbar"
      />
      <Dialog
        open={tableDialog}
        onClose={() => {
          setTableDialog(false);
        }}
      >
        <DialogTitle>Create New Table</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Table Name"
            fullWidth
            variant="standard"
            value={tableName}
            error={tableNameError}
            helperText={tableNameError ? tableNameErrorMessage : ""}
            onChange={(e) => {
              setTableName(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setTableDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleAddTable();
            }}
            className="create-table-button"
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={fieldDialog}
        onClose={() => {
          setFieldDialog(false);
          setActiveField(false);
          setFieldName("");
          setFieldType("0");
          setFieldId("");
          setFieldForeign("");
        }}
      >
        <DialogTitle>Add New Field</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Field Name"
            fullWidth
            variant="standard"
            value={fieldName}
            error={fieldNameError}
            helperText={fieldNameError ? fieldNameErrorMessage : ""}
            onChange={(e) => {
              setFieldName(e.target.value);
            }}
          />
          <FormControl
            fullWidth
            className="text-input-margin-top"
            disabled={activeField}
          >
            <InputLabel>Field Type</InputLabel>
            <Select
              value={fieldType}
              label="Method"
              onChange={(e) => setFieldType(e.target.value)}
            >
              {field_types.map((obj, index) => {
                return <MenuItem value={String(index)}>{obj}</MenuItem>;
              })}
            </Select>
          </FormControl>
          {fieldType === "4" ? (
            // <TextField
            //   autoFocus
            //   label="Reference Table Name"
            //   fullWidth
            //   variant="standard"
            //   value={fieldForeign}
            //   disabled={activeField}
            //   error={fieldForeignError}
            //   className="foreign-key-table-name"
            //   helperText={
            //     fieldForeignError ? "Please enter reference table name." : ""
            //   }
            //   onChange={(e) => {
            //     setFieldForeign(e.target.value);
            //   }}
            // />
            <FormControl
              variant="filled"
              fullWidth
              error={fieldForeignError}
              helperText={
                fieldForeignError ? "Please enter reference table name." : ""
              }
            >
              <InputLabel>Reference Table</InputLabel>
              <Select
                value={fieldForeign}
                onChange={(e) => {
                  setFieldForeign(e.target.value);
                }}
                label="Table Name"
                error={fieldForeignError}
                helperText={
                  fieldForeignError ? "Please enter reference table name." : ""
                }
              >
                {tables
                  .filter((obj, index) => {
                    return obj.id !== activeTable;
                  })
                  .map((obj, index) => {
                    return <MenuItem value={obj.name}>{obj.name}</MenuItem>;
                  })}
              </Select>
              <FormHelperText>
                {fieldForeignError ? "Please enter reference table name." : ""}
              </FormHelperText>
            </FormControl>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogContent>
          <p className="feature-message">
            Want more features? Talk to us by opening chat in bottom right
            corner.
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setFieldDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (activeField) handleChangeField();
              else handleNewField();
            }}
            className="create-field-button"
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <div className="topbar">
        <div className="topbar-logo">
          <Link to={"/"}>
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="logo-block"></div>
            </div>
          </Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/workspace/" + projectId}>Workspace</Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/database/" + projectId}>Database</Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/dashboard/" + projectId}>Dashboard</Link>
        </div>
      </div>
      <div className="work-page-content">
        <div className="work-page-sidebar">
          <div className="work-page-sidebar-project">
            <p className="work-page-sidebar-label">Project Name</p>
            <p className="work-page-sidebar-project-name">{proName}</p>
          </div>
          <div className="work-page-sidebar-endpoints">
            <p className="work-page-sidebar-label">Tables</p>
            <Tooltip title="Add new table">
              <a
                href="#"
                className="add-endpoint-card"
                onClick={() => {
                  setTableDialog(true);
                  setTableNameError(false);
                }}
              >
                <AddIcon color="primary" />
              </a>
            </Tooltip>
            {tables.map((obj, index) => {
              return (
                <a
                  className={`endpoint-card ${
                    activeTable === obj.id ? "endpoint-card-active" : ""
                  }`}
                  href="#"
                  key={obj.id}
                  onClick={(e) => {
                    e.preventDefault();
                    handleChangeTable(obj.id);
                  }}
                >
                  <p>{obj.name}</p>
                </a>
              );
            })}
          </div>
        </div>
        <div className="database-content">
          <div className="database-topbar">
            <div className="workspace-topbar-props">
              <div className="endpoint-chip">
                <p className="endpoint-title">Apply Changes to Database:</p>
                <Tooltip title="Apply Database Changes">
                  <IconButton
                    className="tool-button"
                    onClick={() => {
                      handleApplyDatabase();
                    }}
                  >
                    <ApprovalIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            {activeTable ? (
              <div className="workspace-topbar-actions">
                <div className="endpoint-chip">
                  <p className="endpoint-title">Actions:</p>
                  {/* <Tooltip title="Edit Endpoint">
                  <IconButton className="endpoint-button" onClick={() => {}}>
                    <EditIcon fontSize="14px" />
                  </IconButton>
                </Tooltip> */}
                  <Tooltip title="Delete Table">
                    <IconButton
                      className="endpoint-action-delete"
                      onClick={() => {
                        handleRemoveTable(activeTable);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="database-container">
            {fields.map((obj, index) => {
              return (
                <div className="database-field" key={obj.id}>
                  <a
                    href="#"
                    className="database-field-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldName(obj.name);
                      setFieldType(obj.field_type);
                      setFieldId(obj.id);
                      setFieldDialog(true);
                      setActiveField(true);
                      setFieldNameError(false);
                      if (obj.field_type === "4") {
                        setFieldForeign(obj.foreign_key);
                      } else {
                        setFieldForeign("");
                      }
                    }}
                  >
                    <p className="database-field-name">{obj.name}</p>
                    <p className="database-field-type">
                      {field_types[Number(obj.field_type)]}
                    </p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveField(obj.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
              );
            })}
            {activeTable ? (
              <Tooltip title="Add new field">
                <a
                  href="#"
                  className="database-field-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setFieldDialog(true);
                    setFieldNameError(false);
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
